import React from 'react';
import { Grid } from '@mui/material';
import Button from 'components/Button';
import Modal from 'components/Modal/Modal';
import { useLanguage } from 'context/AppContext';

interface DuplicateImageModalProps {
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
  onReplaceImage: () => void;
}

const DuplicateImageModal: React.FC<DuplicateImageModalProps> = ({ open, onClose, onCancel, onReplaceImage }) => {
  const [language] = useLanguage();

  return (
    <Modal open={open} close={onClose} width="30rem">
      <Grid container spacing={1} justifyContent="space-between">
        <Grid item xs={11}>
          <h2>{language.DevicePage.imageAlreadyExists}</h2>
        </Grid>
        <Grid item xs={5}>
          <Button fullWidth onClick={onReplaceImage}>
            {language.DevicePage.replaceImage}
          </Button>
        </Grid>
        <Grid item xs={5}>
          <Button fullWidth onClick={onCancel}>
            {language.DevicePage.cancelDuplicateUpload}
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default DuplicateImageModal;
